import { Button } from "components/Button/Button";
import { TabBar } from "components/Tabbar/Tabbar";
import { useEffect, useRef, useState } from "react";
import { MainForm } from "./components/Main";
import { PackingForm } from "./components/Packing";
import { getNewItemVariation, putItemVariationBranch, sendItemVariationBranch } from "./api";
import { TaxForm } from "./components/Tax";
import { getItemVariationBranch } from "./api"; 
import { VariationsForm } from "./components/VariationsForm";
import { Loading } from "components/Loading/loading";
import { UnitForm } from "./components/Unit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { trans } from "utils/helpers";
   
interface Form { 
  showForm: (e) => void;
  reload?: (flag) => void;
  Id?: any;
  mode: any;
  selectedObj: any;
  checkData: any

}
export const ItemVariationBranchForm = ({ showForm, Id,selectedObj,mode,checkData, reload   }: Form) => {

  const [curentTab, setCurentTab] = useState<any>("main")
  const [response,setResponse] = useState<any>()
  const [loading,setLoading] = useState<boolean>(false)
  const [canPaste,setCanPaste] = useState<any>()

  const itemPropertiesData = useRef<any>([])
  const mainData = useRef<any>()
  const VariationsData = useRef<any>()
  const UnitData = useRef<any>()
  const packingData = useRef<any>()
  const taxData = useRef<any>()
  const lang = localStorage.getItem("DefaultLanguage");

  const formRefs = [useRef(), useRef(),useRef(), useRef()];




  let content = [
    { title: "main", body: (<MainForm checkData={checkData} submitMain={(e)=>{mainData.current=e}} formRef={formRefs[0]} inTab={curentTab} mode={mode} data={response} />), },
    { title: "Unit", body: (<UnitForm checkData={checkData} formRef={formRefs[1]} submitUnit={(e)=>{UnitData.current=e}} inTab={curentTab} mode={mode} data={response} />), },
    { title: "Packing", body: (<PackingForm formRef={formRefs[2]} submitPacking={(e)=>{packingData.current=e}} inTab={curentTab} mode={mode} data={response} />), },
    { title: "TaxSystem", body: (<TaxForm formRef={formRefs[3]} submitTax={(e)=>{taxData.current=e}} inTab={curentTab} mode={mode}  data={response} />), },
   // mode!="edit"&&{ title: "ItemProperties", body: (<ItemProperties  selectedObj={selectedObj} getPropertiItems={(e)=>{itemPropertiesData.current=e}} mode={mode} inTab={curentTab} />), },

  ];

  const tabChangeHandle = (tab) => {
    setCurentTab(tab)
  } 
  async function formSubmit() {
        if(mode=="create"){
          try {
            await delay(50)
            let data = {
              ParentId: selectedObj.Id,
              "ParentLayerLeafId": checkData.ParentLayerLeafId  ,
              "GroupLeafId": checkData.GroupLeafId,
              "ItemLayerType": checkData.ItemLayerType,
              ...{...mainData.current ,...UnitData.current,...packingData.current,...taxData.current },               
            }
            await sendItemVariationBranch(data )
            showForm(true)
          } catch (error) {
  
          }
        }else{
          await delay(50)
          let formdata: any = {}
          formdata = {
            Id:selectedObj.Id ,
            ParentId: selectedObj?.ParentId,
            "ParentLayerLeafId": checkData.ParentLayerLeafId,
            "GroupLeafId": checkData.GroupLeafId,
            IsLeaf:response.IsLeaf,
            "ItemLayerType": checkData.ItemLayerType,
             ...mainData.current ,...UnitData.current,...packingData.current,...taxData.current }
          try {
              await putItemVariationBranch(formdata )
              showForm(true)
          } catch (error) {
      
          }
        }
        document.body.classList.remove("loading-indicator-"+lang);
}

const getItemVariationBranchAsync =async () => {
  setLoading(false)
  try {
    const res = await getItemVariationBranch(selectedObj.Id)
    setResponse(res?.Data)
  } catch (error) {
    
  }
  setLoading(true)
}
const getNewItemVariationAsync =async () => {
  setLoading(false)
  try {
    const res = await getNewItemVariation(selectedObj.Id)
    setResponse(res?.Data)
  } catch (error) {
    
  }
  setLoading(true)
}
async function checkPaste() {
  try {
      
      let data =await navigator.clipboard.readText()
      if(data && JSON.parse(data)){
          setCanPaste(true)
      }
  } catch (error) {
      setCanPaste(false)

  }
}
const pasteHandler = async() => {
 const text =JSON.parse( await navigator.clipboard.readText());
    setResponse(text)
  try {
  } catch (error) {
      
  }  
}
useEffect(() => {
  if(selectedObj?.Id && mode !="create"){
    getItemVariationBranchAsync()
  }else if(selectedObj?.Id && mode =="create") {
    getNewItemVariationAsync()
  }else{
    setLoading(true)
  }
  checkPaste()
}, [selectedObj]);


  const delay = (duration) =>
  new Promise(resolve => setTimeout(resolve, duration));

  const handleSubmitAllForms = async(e) => {
    document.body.classList.add("loading-indicator-"+lang);
  let flag=true ; 
  await Promise.all(
    formRefs.map(async (formRef:any, index) => {        
      if(mode=="create"||index<4)           
      if(formRef.current.checkValidity()&&flag){                   
        formRef.current.hidebutton?.click();                   
      }else if(flag){                   
        flag = false                   
        setCurentTab(formRef.current.name)                   
        await delay(50)                   
        formRef.current.reportValidity()                   
      }                   
    })                   
  );                   
  await delay(50)                   
  if(mainData.current!=undefined && taxData.current!=undefined&&flag){                   
      formSubmit()                   
  }  else{
    document.body.classList.remove("loading-indicator-"+lang);
  }                   
                   
  };                   
  return (
    <>
    {loading ? 
    <>
            {(canPaste&&mode!="view")&&
            <div onClick={()=>{pasteHandler()}} className="col-2  btn btn-primary btn-sm d-flex align-items-center justify-content-between " style={{zIndex:"1",  width:'89px' , maxHeight:"30px", marginRight:"20px" , position:"absolute" , left:"5px"}}>
                <span className=" font-size-md ">{trans('paste')}</span>
                <FontAwesomeIcon size="xs" icon={['fas', 'paste']} className="color_text_light d-flex Requests__chatbox-reply-btn mx-1"   color='white' />
            </div>                    
         }
      <TabBar  tabChange={tabChangeHandle} content={content} curentTab={curentTab} defaultTab={"main"} />
      <div className="d-flex justify-content-end mt-2">
        { mode != "view"?
        <Button onClick={handleSubmitAllForms} btnType="submit" value="save"  />
        :
        <Button onClick={()=>showForm(false)} btnType="primary" value="Close"  />                                                                                                                                                              
        }
      </div>
    </>
    :
    <Loading />  
  }
    </>
  )
}